import React, { useState } from "react";
import { Tab, Nav, Form } from "react-bootstrap";
import Pagination from "react-bootstrap/Pagination";
import { Link, useNavigate } from "react-router-dom";
import clientimg from "../../asset/images/onboarding-pending/client-img.jpg";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Header from "../../Components/Header";
import Sidebar from "../../Components/Sidebar";
import Loader from "../../Components/Common/Loader";

import {
  ApiResDecrypt,
  decryptString,
  getName,
  getTabStatus,
  goToClientDashboard,
  mobileNumber,
  noDataFound,
  safeDecryptString,
  splitDate,
} from "../../CommonMethhods/CommonMethods";
import { Constants } from "../../CommonMethhods/Constants";

function OnboardingCreatedClient(props) {
  let filteredCreated = props.checkCreatedClient;
  let linecard = props.linecard;
  let navigate = useNavigate();
  let serverError = props.serverError;

  console.log(filteredCreated, "filteredCreated");
  
  return (
    <>
      <Tab.Pane eventKey="Created" className="createdClass">
        <div className="row">
          <div className="col-12">
            <div
              className="oboarding-block-wrapper card-box alert-table text-center"
              onScroll={(e) => props.handleScroll(e)}
            >
              {filteredCreated.length > 0 ? (
                <div
                  className={` ${
                    linecard === "block-active col-division-5"
                      ? "onboarding-card-wrapper"
                      : ""
                  }`}
                >
                  {filteredCreated.map((item, index) => {
                    const decryptedPan = item?.pan ? decryptString(item.pan) : "";
                    const decryptedMobile = item?.mobile ? decryptString(item?.mobile) : "";
                    
                    return (
                      <div className={`w-100 bottom-25 ${linecard}`}>
                        <a
                          onClick={() => {
                            goToClientDashboard(item.clientCode, decryptedPan)
                            getTabStatus(props.filterData)
                            navigate("/client-dashboard");
                          }}
                          className="view-detail-btn"
                        >
                          <div className="card-box onboarding-card">
                            <div className="client-img-checkbox-wrapper">
                              <div className="client-img-wrapper">
                                <div className="profile-image">
                                  {item?.clientname
                                    ? getName(item?.clientname)
                                    : "N.A"}
                                </div>
                              </div>
                            </div>
                            <div className="onboarding-card-content">
                              <div className="onboarding-card-top">
                                <div className="user-email-wrapper">
                                  <p className="username">
                                    <span>{item?.clientname || "N.A"}</span>
                                  </p>{" "}
                                  <p className="email">
                                    {item?.emailid ? item?.emailid : "N.A"}
                                  </p>
                                </div>
                                <ul className="onboarding-content-link-list">
                                  {/* <li className="fingerprint-icon-wrapper">
                                    <span className="icon-fingerprint fingerprint-icon"></span>
                                  </li> */}
                                  {/* <li className="user-icon-wrapper">
                                    <span className="icon-verified-user"></span>
                                  </li> */}
                                  {/* <li className="onboard-new-link">
                                    <Link to="#" className="">
                                      {Constants.New}
                                    </Link>
                                  </li> */}
                                </ul>
                              </div>
                              <div className="clientname-info">
                                <ul className="call-web-wrapper">
                                  <li className="created-time-wrapper">
                                    <span className="icon-calendar onboard-pending-icon"></span>
                                    <span className="onboard-sm-icon-label">
                                      <span>
                                        {item?.createddatetime
                                          ? splitDate(item?.createddatetime)
                                          : "N.A"}
                                      </span>
                                    </span>
                                  </li>
                                  <li className="created-time-wrapper">
                                    <span className="icon-client-code onboard-pending-icon"></span>
                                    <span className="onboard-sm-icon-label">
                                      <span>{item?.clientCode || "N.A"}</span>
                                    </span>
                                  </li>
                                </ul>
                                <div className="client-info-status">
                                  <ul className="call-web-wrapper">
                                    <li>
                                      <span className="icon-phone-icon onboard-pending-icon"></span>
                                      <span className="onboard-sm-icon-label">
                                        <span>
                                           {decryptedMobile
                                            ? mobileNumber(decryptedMobile)
                                            : "N.A"}
                                          {/* {item?.mobile ? item?.mobile : "N.A"} */}
                                        </span>
                                      </span>
                                    </li>
                                    <li>
                                      <span className="icon-android onboard-pending-icon"></span>
                                      <span className="onboard-sm-icon-label">
                                        <span>
                                          {decryptedPan
                                            ? mobileNumber(decryptedPan)
                                            : "N.A"}
                                        </span>
                                      </span>
                                    </li>
                                    {!linecard && (
                                      <li>
                                        <span className="icon-verified-user onboard-pending-icon"></span>
                                        <span className="onboard-sm-icon-label">
                                          DDPI-(
                                          <span>{item?.ddpi || "NA"}</span>)
                                        </span>
                                      </li>
                                    )}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </a>
                      </div>
                    );
                  })}
                </div>
              ) : (
                serverError && (
                  <h4 className="alert-title mb-0">
                    {noDataFound(serverError)}
                  </h4>
                )
              )}
              {props.scrollLoader && (
                <div className="loader-center">
                  <Loader />
                </div>
              )}
            </div>
          </div>
        </div>
      </Tab.Pane>
    </>
  );
}

export default OnboardingCreatedClient;
